module.exports = __webpack_public_path__ + "img/TS-Symbol-bk.5118e951.svg";